<template>
  <div v-if="$vuetify.breakpoint.smAndDown" class="game-menu">
    <div>
      <v-row no-gutters id="game-menu">
        <v-row no-gutters id="game-menu-full" class="game-menu-wrapper" style="width: 100%">
          <v-btn
            v-if="this.storageHomepageHotGames"
            @click="selectGameType('', -1)"
            height="auto"
            text
            :ripple="false"
            depressed
            :class="['game-menu-content font-weight-bold', [$vuetify.breakpoint.mdAndDown ? 'caption' : 'subtitle-1'], [dActiveGameType == 'homepageHot' ? 'selected' : '']]"
          >
            <div class="game-menu-image" :style="`--src: url('/static/svg/mobileMenu/Hot.svg')`">
              <!--              <img :url="`../../assets/svg/side nav/hot-salefes.png`" class="side-menu-icon"/>-->
            </div>
            <div class="game-menu-title">{{ $t(`label.hotGames`) }}</div>
            <!--          </v-card>-->
          </v-btn>
          <v-btn
            v-for="(gameType, index) in storageGameProviderType"
            :key="gameType.type"
            @click="selectGameType(gameType, index)"
            height="auto"
            text
            :ripple="false"
            depressed
            :class="['game-menu-content font-weight-bold', [$vuetify.breakpoint.mdAndDown ? 'caption' : 'subtitle-1'], [dActiveGameType == gameType.type ? 'selected' : '']]"
          >
            <div class="game-menu-image" :style="`--src: url('/static/svg/mobileMenu/${gameType.type}.svg')`">
              <!-- <img :url="`/static/svg/mobileMenu/${gameType.type}.svg`" :alt="gameType.type" class="side-menu-icon"/> -->
            </div>
            <div class="game-menu-title">{{ $t(`label.${gameType.type}_short`) }}</div>
          </v-btn>
        </v-row>

        <!--      <v-row no-gutters id="game-menu-mini" class="game-menu-wrapper fixed-top">-->
        <!--        &lt;!&ndash;HotGames&ndash;&gt;-->
        <!--        <v-btn v-for="(hotGames, i) in storageHomepageHotGames"  :key="hotGames.code"-->
        <!--               @click="!isGameMaintenance(hotGames.type, hotGames.provider) ? launchGame(hotGames,false) : {}"-->
        <!--               min-width="45px" height="auto" text :ripple="false" depressed-->
        <!--               class="game-menu-content font-weight-bold"-->
        <!--               :class="`gT_${HomePageHotString}`" >-->
        <!--        </v-btn>-->

        <!--&lt;!&ndash;        Repeated&ndash;&gt;-->
        <!--        <v-btn v-for="(gameType, index) in storageGameProviderType" :key="gameType.type"-->
        <!--               @click="selectGameType(gameType, index)"-->
        <!--               min-width="45px" height="auto" text :ripple="false" depressed-->
        <!--               class="game-menu-content font-weight-bold"-->
        <!--               :class="$vuetify.breakpoint.mdAndDown ? 'caption' : 'subtitle-1'">-->
        <!--          <div>{{ $t(`label.${gameType.type}_short`) }}</div>-->
        <!--        </v-btn>-->

        <!--        <v-btn v-for="(gameType, index) in storageGameProviderType" :key="gameType.type"-->
        <!--               @click="selectGameType(gameType, index)"-->
        <!--               min-width="45px" height="auto" text :ripple="false" depressed-->
        <!--               class="game-menu-content font-weight-bold"-->
        <!--               :class="$vuetify.breakpoint.mdAndDown ? 'caption' : 'subtitle-1'">-->
        <!--          <div>{{ $t(`label.${gameType.type}_short`) }}</div>-->
        <!--        </v-btn>-->
        <!--      </v-row>-->
      </v-row>
      <!--    Homepage Hot game card-->
      <div class="mt-0 hidden-md-and-up game-card-box px-4 py-2" v-if="dActiveGameType == HomePageHotString">
        <div class="game-card-box-wrapper hotgame">
          <div
            class="game-card-box-item d-flex"
            :class="`gT_${HomePageHotString}`"
            v-for="(hotGames, i) in storageHomepageHotGames.slice(0, visibleGameCards)"
            :key="hotGames.code"
            @click="!isGameMaintenance(hotGames.type, hotGames.provider) ? launchGame(hotGames, false) : {}"
          >
            <!--          :src="hotGames.imageCdn == null ? `${mediaUrl}/game_icons/en/${hotGames.provider}/${hotGames.code}_${hotGames.id}.jpg` : `${hotGames.imageCdn}`"-->
            <v-img class="banner-img d-flex justify-center align-center" contain :alt="hotGames.provider">
              <img
                :class="['homepageHot_img']"
                :src="hotGames.imageCdn == null ? `${mediaUrl}/game_icons/en/${hotGames.provider}/${hotGames.code}_${hotGames.id}.jpg` : `${hotGames.imageCdn}`"
                @error="$event.target.src = '/static/image/icon/broken-image.png'"
              />
              <v-overlay v-if="isGameMaintenance(hotGames.type, hotGames.provider)" absolute opacity="0.8" class="gameMaintenanceOverlay">
                <label class="text-uppercase font-weight-bold">{{ $t(`label.underMaintenance`) }}</label>
              </v-overlay>
              <img src="/static/image/icon/hot-icon.png" class="img-hot-home pos_right_top" />
            </v-img>
            <span class="smallTextGameLocale">{{ getGameName(hotGames.locale) }}</span>
            <!--        <span v-if="dActiveGameType == 'rng'" class="rng_providerLabel">{{ $t(`label.custom_${provider.providerCode}`) }}</span>-->
          </div>

          <div id="autoFillEle1" class="game-card-box-item gT_homepageHot" style="max-height: 0px !important">
            <v-img max-height="0" :src="'/static/image/rng_pp.jpg'" class=" banner-img"></v-img>
          </div>
          <div id="autoFillEle2" class="game-card-box-item gT_homepageHot" style="max-height: 0px !important">
            <v-img max-height="0" :src="'/static/image/rng_pp.jpg'" class=" banner-img"></v-img>
          </div>
        </div>
      </div>

      <!--    Usual Gametype-->
      <div class="mt-0 hidden-md-and-up game-card-box px-4 py-2" v-else>
        <!--         :class="this.dActiveGameType == 'ld' || this.dActiveGameType == 'rng'|| this.dActiveGameType == 'crash' ? 'ld-gap' : ''">-->

        <div class="game-card-box-wrapper">
          <div class="game-card-box-item" :class="`gT_${dActiveGameType}`" v-for="provider in gameContainer1.providers.slice(0, visibleProvider)" :key="provider.providerCode">
            <v-img
              @click="!isGameMaintenance(gameContainer1.type, provider.providerCode) ? accessGame(gameContainer1.type, provider.providerCode) : {}"
              contain
              class="game-card-image-avatar d-flex justify-center align-center"
              :alt="provider.providerCode"
              width="auto"
            >
              <img
                :class="['homepageHot_img']"
                :src="`${mediaUrl}/vendor-card/${gameContainer1.type}/${provider.providerCode}_avatar.png`"
                @error="$event.target.src = '/static/image/icon/broken-image.png'"
              />
              <v-overlay v-if="isGameMaintenance(gameContainer1.type, provider.providerCode)" absolute opacity="0.8" class="gameMaintenanceOverlay">
                <label class="text-uppercase font-weight-bold">{{ $t(`label.underMaintenance`) }}</label>
              </v-overlay>
              <img src="/static/image/icon/hot-icon.png" class="img-hot-home pos_right_top" alt="hot" v-if="isHotProvider(provider.providerCode)" />
              <img src="/static/image/icon/new_icon.png" class="img-new-home pos_right_top" alt="new" v-if="isNewProvider(provider.providerCode)" />
              <!--            <v-icon color="#f56909" class="pos_right_top" v-if="isHotProvider(provider.providerCode)">mdi-fire-->
              <!--            </v-icon>-->
            </v-img>
            <label v-if="dActiveGameType === 'table'" class="text-capitalize d-flex justify-center holder_text">{{ $t(`label.custom_${dActiveGameType}_${provider.providerCode}`) }}</label>
            <label v-else class="text-capitalize d-flex justify-center holder_text">{{ $t(`label.custom_${provider.providerCode}`) }}</label>
          </div>
        </div>
      </div>
      <v-row no-gutters v-if="dActiveGameType == HomePageHotString">
        <v-col cols="12" class="" v-if="storageHomepageHotGames.length > 4">
          <v-btn @click="loadMoreGames" class="viewBtn">
            {{ visibleGameCards === 4 ? $t('label.viewMore') : $t('label.viewLess') }}
            <v-icon>{{ visibleGameCards === 4 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters v-else>
        <v-col cols="12" class="" v-if="gameContainer1.providers.length > 4">
          <v-btn @click="loadMoreProviders" class="viewBtn">
            {{ visibleProvider === 4 ? $t('label.viewMore') : $t('label.viewLess') }}
            <v-icon>{{ visibleProvider === 4 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { uiHelper } from '@/util'
import { CACHE_KEY, SESSION } from '@/constants/constants'
import { ROUTE_NAME } from '@/constants/route.constants'
import { SHARED } from '@/constants/constants'
import { SEMI_TRANSFER } from '@/store/transfer.module'
import _forEach from 'lodash/forEach'
import { GAME_HOMEPAGE_HOT, GAME_PROVIDERS_TYPE_CONFIG } from '@/store/game.module'

export default {
  name: 'appGameCard',
  data: () => ({
    visibleGameCards: 4,
    visibleProvider: 4,
    routeName: ROUTE_NAME,
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    storageGameProviderType: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_PROVIDER_TYPE}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    storageHomepageHotGames: uiHelper.setLocalStorage(`${CACHE_KEY.HOMEPAGE_HOTGAMELIST}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    selectedGameCard: '',
    gameContainer1: {},
    gameContainer2: {},
    dActiveGameType: 'ld',
    HomePageHotString: 'homepageHot',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    slotAspRatio: 1 / 1
  }),
  computed: {
    BanneAspRatio() {
      let _aspRatio = 1 / 1
      switch (this.dActiveGameType) {
        case 'ld':
          _aspRatio = this.ldAspRatio
          break
        case 'rng':
        case this.HomePageHotString:
          _aspRatio = this.slotAspRatio
          break
        case 'cricket':
          _aspRatio = 1200 / 400
          break
        case 'table':
          _aspRatio = this.tableAspRatio
          break
        case 'sb':
          _aspRatio = 1200 / 400 //temp set as 4:1, should be 3:1
          break
        case 'fishing':
          _aspRatio = 0
          break
        case 'lottery':
          _aspRatio = 0
          break
        case 'crash':
          _aspRatio = this.crashAspRatio
          break
      }
      return _aspRatio
    },
    ActiveMobileGameType() {
      return this.dActiveGameType
    },
    ProviderTypes() {
      return this.$store.state.game.ProviderTypes
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    calctab() {
      return this.text.replace('Lorem', 'tab2')
    },
    homepageHotGames() {
      return this.$store.state.game.HomepageHotGames
    }
  },
  watch: {
    ProviderTypes() {
      this.storageGameProviderType = this.$store.state.game.ProviderTypes
      this.selectGameType('', 0)
    },
    ActiveMobileGameType() {
      return this.dActiveGameType
    },
    homepageHotGames() {
      this.storageHomepageHotGames = this.$store.state.game.HomepageHotGames
    }
  },
  created() {
    this.selectGameType('', 0)
    this.getHomepageHotGames()
  },
  methods: {
    getGameName(gameLocale) {
      try {
        return gameLocale.find(x => x.language == this.currentLanguage).name
      } catch (error) {
        return gameLocale.find(x => x.language == 'en').name
      }
    },
    loadMoreGames() {
      if (this.visibleGameCards === 4) {
        this.visibleGameCards = this.storageHomepageHotGames.length
      } else {
        this.visibleGameCards = 4
      }
    },
    loadMoreProviders() {
      if (this.visibleProvider === 4) {
        this.visibleProvider = this.gameContainer1.providers.length
      } else {
        this.visibleProvider = 4
      }
    },
    showAndroidToast() {
      // AndroidFunction.isAndroid();
      // AndroidFunction.isMobile()
      // Android.showToast(toast);
      // Android.biometric();
    },
    isNewProvider(provider) {
      let arr = ['jdb', 'haba', 'spribe', 'ludo', 'pt']
      return arr.indexOf(provider.toLowerCase()) > -1
    },
    isHotProvider(provider) {
      let arr = ['jili', 'evo', 'betswiz', 'pp', 'sexy_v2', 'spg']
      return arr.indexOf(provider.toLowerCase()) > -1
    },
    openLoginDialog() {
      this.$parent.openLoginDialog()
    },
    tabfunc() {
      let t = this.tab.split('-')
      let index = parseInt(t[1]) + 1
      this.tab2 = 'tab-' + index
      console.log(this.tab2)
      console.log(this.tab)
    },
    selectGameType(gameType, index) {
      this.dActiveGameType = gameType != '' && gameType != undefined ? gameType.type : 'homepageHot'
      if (gameType == '' && index == -1) return

      uiHelper.setCookie(SESSION.FAVOURITE_GAME, index, 30)
      if (this.storageGameProviderType) {
        if (this.$vuetify.breakpoint.mdAndUp) {
          if (index + 1 < this.storageGameProviderType.length) {
            this.gameContainer1 = this.storageGameProviderType[index]
            this.gameContainer2 = this.storageGameProviderType[index + 1]
          } else {
            this.gameContainer1 = this.storageGameProviderType[index - 1]
            this.gameContainer2 = this.storageGameProviderType[index]
          }
          _forEach(this.storageGameProviderType, function(gameType) {
            gameType.selected = false
          })
          this.gameContainer1.selected = true
          this.gameContainer2.selected = true
        } else {
          this.gameContainer1 = this.storageGameProviderType[index]
          this.gameContainer2 = this.storageGameProviderType[index]
          _forEach(this.storageGameProviderType, function(gameType) {
            gameType.selected = false
          })
          this.gameContainer1.selected = true
        }
      }
      this.visibleGameCards = 4
      this.visibleProvider = 4
      console.log(this.gameContainer1)
    },
    async directLaunchGame(gameInfo, isDemo) {
      let routeData = this.$router.resolve({
        name: ROUTE_NAME.LAUNCH_GAME_LOBBY,
        params: {
          provider: gameInfo.provider,
          type: gameInfo.type,
          lang: this.$route.params.lang
        },
        query: {
          id: gameInfo.id,
          code: gameInfo.code,
          demo: isDemo ? 1 : 0
        }
      })
      try {
        this.$ga.event('Game', `${isDemo ? 'Demo' : 'Real'} Play`, `${gameInfo.provider.toUpperCase()} - Slot - ${gameInfo.locale.find(x => x.language == 'en').name}`, gameInfo.id)
      } catch (err) {
        console.log(err)
      }
      if (gameInfo.type == 'sb' || gameInfo.type == 'cricket') {
        await uiHelper.openNewTab(routeData.href, 'Game Play Lobby', 1440, 810)
        this.semiTransfer(gameInfo.provider)
      } else {
        this.semiTransfer(gameInfo.provider).then(() => {
          uiHelper.openNewTab(routeData.href, 'Game Play Lobby', 1440, 810)
        })
      }
    },
    launchGame(gameInfo, isDemo) {
      if (!isDemo && !this.isLoggedIn) {
        this.$parent.openLoginDialog()
      } else {
        this.directLaunchGame(gameInfo, isDemo)
      }
    },
    getHomepageHotGames() {
      if (!this.storageHomepageHotGames) {
        let obj = {
          currency: uiHelper.getCurrency(),
          platform: uiHelper.getPlatform(),
          size: '',
          page: '',
          mode: 'All'
        }
        this.$store.dispatch(`${GAME_HOMEPAGE_HOT}`, { obj })
      }
    },
    isGameMaintenance(gameType, providerCode) {
      if (
        this.storageGameProviderType == null ||
        this.storageGameProviderType.find(x => x.type == gameType) == undefined ||
        this.storageGameProviderType.find(x => x.type == gameType).providers.find(x => x.providerCode == providerCode) == undefined
      ) {
        return false
      } else {
        return this.storageGameProviderType.find(x => x.type == gameType).providers.find(x => x.providerCode == providerCode).isMaintenance
      }
    },
    async accessGame(type, providerCode) {
      console.log(providerCode)
      this.showAndroidToast()
      let gaType = ''
      switch (type) {
        case 'sb':
          gaType = 'Sportsbook'
          break
        case 'fishing':
          gaType = 'Fishing'
          break
        case 'ld':
          gaType = 'Casino'
          break
        case 'special':
          gaType = 'Special'
          break
      }
      // if (!this.isLoggedIn && uiHelper.getPlatform() == DevicePlatform.MOBILE && type != 'rng' && type != 'special') {
      //     this.openLoginDialog()
      // }
      // else {
      if (type == 'rng') {
        this.$router.push({
          name: ROUTE_NAME.SLOT_BY_PROVIDER,
          params: {
            provider: providerCode
          }
        })
      } else if (type == 'lottery') {
        this.$router.push({
          name: ROUTE_NAME.LOTTERY_BY_PROVIDER,
          params: {
            provider: providerCode
          }
        })
      } else if (type == 'crash') {
        this.$router.push({
          name: ROUTE_NAME.CRASH_BY_PROVIDER,
          params: {
            provider: providerCode
          }
        })
      } else if (type == 'table') {
        this.$router.push({
          name: ROUTE_NAME.TABLE_GAMES_BY_PROVIDER,
          params: {
            provider: providerCode
          }
        })
      } else if (type == 'special') {
        this.$router.push({
          name: ROUTE_NAME.SPECIAL_BY_PROVIDER,
          params: {
            provider: providerCode
          }
        })
      } else {
        if (this.isLoggedIn) {
          let routeData = this.$router.resolve({
            name: ROUTE_NAME.LAUNCH_GAME_LOBBY,
            params: {
              provider: providerCode,
              type: type,
              lang: this.$route.params.lang
            },
            query: {
              demo: 0
            }
          })
          try {
            this.$ga.event('Game', 'Real Play', `${providerCode.toUpperCase()} - ${gaType}`)
          } catch (err) {
            console.log(err)
          }
          if (type == 'sb' || type == 'cricket') {
            await uiHelper.openPopup(routeData.href, 'Game Play Lobby', 1440, 810)
            this.semiTransfer(providerCode)
          } else {
            this.semiTransfer(providerCode).then(() => {
              uiHelper.openPopup(routeData.href, 'Game Play Lobby', 1440, 810)
            })
          }
        } else {
          this.openLoginDialog()
        }
      }
      //}
    },
    semiTransfer(providerCode) {
      let obj = {
        to_wallet: providerCode
      }
      return this.$store.dispatch(`${SEMI_TRANSFER}`, { obj })
    }
  },

  ready: function() {}
}
//
// window.addEventListener('scroll', function (event) {
//   const gameMenu = document.getElementById('game-menu');
//
//   if (gameMenu) {
//     const gameMenuFull = document.getElementById('game-menu-full');
//     const gameMenuMini = document.getElementById('game-menu-mini');
//     const scrollTop = document.documentElement.scrollTop;
//
//     if (scrollTop > 300) {
//       gameMenuFull.style.opacity = 0;
//       gameMenuMini.style.opacity = 1;
//     } else {
//       gameMenuFull.style.opacity = 1;
//       gameMenuMini.style.opacity = 0;
//     }
//   }
//
//
// });
</script>

<style lang="scss">
.smallTextGameLocale {
  font-size: 9px;
  display: flex;
  justify-content: center;
}
.viewBtn {
  background-color: #dbdbdb !important;
  text-transform: none;
  width: 100%;
}
.fixed-top {
  position: fixed;
  opacity: 0;
  top: 44px;
  width: 100%;
  background-color: var(--v-background-base);
  z-index: 1;
}

.transform-game-image {
  transform: translateY(-100px);
  transition: transform 0.5s ease-in-out;
}

.game-menu {
  background-color: var(--v-text_reverse-base);

  .game-menu-wrapper {
    max-width: 1240px;
    white-space: nowrap;
    margin: auto;
    overflow: auto;
    flex-wrap: nowrap;
    display: block;
    justify-content: space-evenly;
    align-items: center;
    background-color: var(--v-text-base);
    box-shadow: 2px 2px 12px -4px black;
  }

  .game-menu-content {
    min-width: auto !important;
    width: 78px;
    flex-grow: 1;
    text-transform: capitalize;
    padding: 10px 12px !important;
    background: white;
    color: var(--v-secondary-base);

    .v-btn__content {
      display: flex;
      flex-direction: column;
    }

    .game-menu-image {
      background-color: #ff7700;
      -webkit-mask-image: var(--src);
      mask-image: var(--src);
      -webkit-mask-size: auto;
      mask-size: 100%;
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      font-size: 5px;
      width: 40px;
      height: 40px;
    }

    .game-menu-title {
      margin-top: 8px;
      font-size: 12px;
      color: #0047ff;
    }
  }

  .game-menu-content:not(:last-child) {
    border-right: 1px solid #f3f3f3;
  }

  //.v-btn {
  //  border-radius: unset;
  //
  //  &:hover::before {
  //    opacity: 1;
  //    background: var(--v-secondary-base);
  //  }
  //
  //  &:hover {
  //    color: white;
  //
  //    .game-menu-image {
  //      background-color: white;
  //    }
  //  }
  //}
}

.game-menu {
  .v-btn {
    border-radius: unset;
  }

  .game-menu-content {
    &.selected {
      color: white;
      opacity: 1;
      background-image: linear-gradient(to bottom, #0047ff, #5a00b4);

      .game-menu-image {
        //background-color: white;
      }
      .game-menu-title {
        color: white;
      }
    }
  }
}

.game-card-box {
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
  min-height: 130px;

  .game-card-label {
    position: relative;
    border-left: 4px solid var(--v-primary-base);
    padding-left: 4px;
  }

  .game-card-box-wrapper {
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;
    gap: 4px;
    animation: game-card-box-wrapper 0.5s ease-in-out;
    margin-top: 12px;
    justify-content: left;

    &.hotgame {
      justify-content: space-evenly;
    }

    .game-card-box-item {
      flex: 0 0 25%;
      max-width: 24%;
      padding: 4px;
      font-size: 12px;
      color: black;
      height: auto !important;
      flex-direction: column;
      display: flex;

      &.gT_homepageHot {
        min-width: 22%;
        max-width: 22%;
        height: auto !important;
        flex-direction: column;
        padding: 4px;
      }

      .homepageHot_img {
        height: auto;
        width: 100%;
      }
    }
  }

  @keyframes game-card-box-wrapper {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0%);
    }
  }
}

.pos_right_top {
  position: absolute !important;
  right: 3px;
  top: 2px;
}

.img-hot-home {
  width: 20px;
  animation: beat 1s infinite alternate;
}

.img-new-home {
  width: 30px;
  top: 7px;
  animation: beat 1s infinite alternate;
}

@keyframes beat {
  to {
    transform: scale(1.15);
  }
}

@media screen and (max-width: 450px) {
  .smallTextGameLocale {
    font-size: 7px;
  }
}

@media screen and (max-width: 380px) {
  .smallTextGameLocale {
    font-size: 5px;
  }
}
@media screen and (max-width: 350px) {
  .holder_text {
    font-size: 9px;
  }
}
</style>
